import { Navigate } from 'react-router-dom';
import DashboardLayout from './components/DashboardLayout';
import MainLayout from './components/MainLayout';

import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Settings from './pages/Settings';
import NotFound from './pages/NotFound';
import LandingPage from './pages/LandingPage';

// Dashboard de Afiliados
import DashboardAfiliados from './pages/DashboardAfiliados';

// Canais (Afiliados)
import AfiliadosList from './pages/Afiliados/AfiliadosList';
import AfiliadoAdd from './pages/Afiliados/AfiliadoAdd';

// Links de Afiliado
import LinksList from './pages/Links/LinksList';
import LinkAdd from './pages/Links/LinkAdd';

// Vendas
import SalesList from './pages/Vendas/SalesList';

// Comissões
import CommissionsList from './pages/Comissoes/CommissionsList';

// Perfil de Afiliado
import PerfilAfiliadoEdit from './pages/PerfilAfiliado/PerfilAfiliadoEdit';
import PerfilAfiliadosList from './pages/PerfilAfiliado/PerfilAfiliadosList';

// Usuários (Admin)
import UsuarioAdd from './pages/Usuario/UsuarioAdd';
import UsuarioEdit from './pages/Usuario/UsuarioEdit';
import UsuarioList from './pages/Usuario/UsuarioList';
import UsuarioView from './pages/Usuario/UsuarioView';

import PerfilEdit from './pages/Perfil/PerfilEdit';

const routes = [
  {
    path: 'app',
    element: <DashboardLayout />,
    children: [
      // Dashboard Principal
      { path: 'dashboard', element: <DashboardAfiliados /> },

      // Canais de Afiliados
      { path: 'afiliados', element: <AfiliadosList /> },
      { path: 'afiliado', element: <AfiliadoAdd /> },
      { path: 'afiliado/:id/edit', element: <AfiliadoAdd /> },
      { path: 'afiliado/:id/view', element: <AfiliadoAdd /> },

      // Links de Afiliado
      { path: 'links', element: <LinksList /> },
      { path: 'link', element: <LinkAdd /> },

      // Vendas
      { path: 'vendas', element: <SalesList /> },

      // Comissões
      { path: 'comissoes', element: <CommissionsList /> },

      // Perfil de Afiliado
      { path: 'perfil-afiliado', element: <PerfilAfiliadoEdit /> },

      // Admin - Perfis de Afiliados
      { path: 'admin/perfis-afiliados', element: <PerfilAfiliadosList /> },

      // Usuários (Admin)
      { path: 'usuarios', element: <UsuarioList /> },
      { path: 'usuario', element: <UsuarioAdd /> },
      { path: 'usuario/:id/edit', element: <UsuarioEdit /> },
      { path: 'usuario/:id/view', element: <UsuarioView /> },

      // Configurações e Perfil
      { path: 'perfil', element: <PerfilEdit /> },
      { path: 'settings', element: <Settings /> },

      // Rotas de fallback
      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: '/', element: <LandingPage /> },
      { path: 'cadastro', element: <LandingPage /> },
      { path: 'login', element: <Login /> },
      { path: 'register', element: <Register /> },
      { path: 'forgot-password', element: <ForgotPassword /> },
      { path: 'reset-password', element: <ResetPassword /> },
      { path: '404', element: <NotFound /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  }
];

export default routes;
